module.exports = __webpack_public_path__ + "static/media/mercuryLogo.2d8940ad.png";